import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { KeycloakService } from '../../../../../usermgmt/src/lib/services/keycloak.service';
import { TokenService } from 'usermgmt';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    error!: string;
    statusCodes: any;
    errorMsgConfig: any = {};

    constructor(
          private http: HttpClient,
        private tokenservice : TokenService,
        private keyCloakSrv : KeycloakService,
        private router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap({
            next: () => {
                // do anything with the response if necessary
            },
            error: async (error) => {
                if (error instanceof HttpErrorResponse) {
                    // View creation is optional. A failure there must not log the user out
                    // or send the rest of the portal to the deployment page.
                    if (request.url.includes('view_creation/')) {
                        return;
                    }

                    //  this.errorMsgConfig = await this.cmnSrv.loadConfig({
                    //     path: Path.ERROR_MESSAGE_CONFIG_PATH,
                    //     configType: Config.ERROR_MESSAGE_CONFIG
                    // })
                    
                    // if (error.status === 401) {
                    //     this.tokenservice.showtoaster()
                    //     setTimeout(() => {
                    //         this.keyCloakSrv.logout();
                    //     }, 1000);
                    //     return
                    // } 
                      if (error.status === 401) {
                         console.log('401 error intercepted');
                    
                                            const isPortal = localStorage.getItem('isportal');
                                            console.log('isPortal value:', isPortal);
                    
                                            if (isPortal&&request.url.includes('/api/lps_user_management/')) {
                                                const refreshToken = localStorage.getItem('refresh_token1');
                                                console.log('Refresh token:', refreshToken);
                    
                                                if (refreshToken) {
                                                    return this.refreshToken(refreshToken).pipe(
                    
                                                        switchMap((res: any) => {
                    
                                                            const newAccessToken = res?.result?.access_token;
                    
                                                            // ✅ Save new token
                                                            localStorage.setItem('access_token1', newAccessToken);
                    
                                                            // ✅ Clone request with new token
                                                            const clonedReq = request.clone({
                                                                setHeaders: {
                                                                    Authorization: `Bearer ${newAccessToken}`
                                                                }
                                                            });
                    
                                                            // ✅ Retry original request
                                                            return next.handle(clonedReq);
                                                        }),
                    
                                                        catchError(() => {
                                                            // this.utilSrv.logout();
                                                            // return throwError(() => error);

                                                             //     this.tokenservice.showtoaster()
                        setTimeout(() => {
                            this.router.navigate(['/portal']);
                        }, 1000);
                        return throwError(() => error);
                                                        })
                                                    ).toPromise();
                                                }
                                            }else{

                                                this.keyCloakSrv.logout();
                                                 return Promise.reject(error);
                                            }
                    
                                        }
                    else if (error.status === 502 || error.status === 503) {
                        this.router.navigate(['/deployment-progress']);
                        return
                    } else {
                        const errorMessage = this.setError(error);
                        return throwError(() => errorMessage);
                    }
                } else {
                    return 
                }
            }
        }));
    }
    // 🔁 Refresh Token API Call
  refreshToken(refreshToken: string) {
    return this.http.post(
      `${environment.url.BACKEND_URL}lps_user_management/auth/refresh_token`,
      {
        refresh_token: refreshToken
      }
    );
  }
    setError(err: HttpErrorResponse): string | Observable<any> {
        let errorMessage!: string;

        if (err.error instanceof ErrorEvent) {
            //client side error
            errorMessage = err.message
        } else {
            //server side error
            // const loggedIn = this.authSrv.isLoggedIn();
            // errorMessage = err.error.message ? err.error.message : this.errorMsgConfig?.[err?.status]?.message;

            // if (err.status === 401) {
            //     this.tokenservice.showtoaster()
            //     return errorMessage;
            // }

            // if (err.status === 400 && loggedIn) {
            //     errorMessage = err.error.message ? { message: err.error.message, code: err.error.statusCode }: this.errorMsgConfig[err?.status]?.message;
            // }

        }
        return errorMessage;
    }
}
